import React, { useState, useMemo } from "react";
import { Collapse, Button, Empty, Pagination } from "antd";
import {
  EyeOutlined,
  PhoneOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

const SLAViolationOrders = ({
  orders,
  violationType,
  loading,
  onViewOrder,
  onRefresh,
}) => {
  const [filteredOrders, setFilteredOrders] = useState(orders);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const paginatedOrders = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filteredOrders.slice(start, start + pageSize);
  }, [filteredOrders, currentPage, pageSize]);

  React.useEffect(() => {
    setFilteredOrders(orders);
    setCurrentPage(1);
  }, [orders]);

  const getContactPhone = (order) => {
    return order.contactPhone;
  };

  const getContactName = (order) => {
    const issueType = order.issue;
    switch (issueType) {
      case "NOT_ACCEPT":
      case "NOT_READY":
        return order.restaurant?.businessInfo?.name;
      case "NOT_PICKED":
        return order.deliveryType === "DELIVERY"
          ? "Delivery Person"
          : `${order.user?.firstName} ${order.user?.lastName}`;
      case "NOT_DELIVERED":
        return "Delivery Person";
      default:
        return null;
    }
  };

  const renderCollapseItems = () => {
    return paginatedOrders.map((order, index) => {
      const phone = getContactPhone(order);
      const contactName = getContactName(order);
      const isDriverIssue = order.deliveryType === "DELIVERY";
      const actorLabel = 
        (order.issue === "NOT_PICKED" || order.issue === "NOT_DELIVERED") &&
        (isDriverIssue ? " (Driver)" : " (Buyer)");

      return {
        key: index,
        label: (
          <p style={{ display: "inline" }}>
            Order #{order.orderCode} -{" "}
            {order.issue?.replace(/_/g, " ").toLowerCase()}
            <span style={{ color: "#888", marginLeft: "8px" }}>
              {actorLabel}
            </span>
          </p>
        ),
        children: (
          <div>
            <ul className="mobile-list-flex">
              <li>
                <span>Date:</span>
                <span>
                  {new Date(order.createdAt).toLocaleString()}
                </span>
              </li>
              <li>
                <span>Customer:</span>
                <span>
                  {order.user?.firstName} {order.user?.lastName || "—"}
                </span>
              </li>
              <li>
                <span>Business:</span>
                <span>{order.restaurant?.businessInfo?.name || "—"}</span>
              </li>
              <li>
                <span>Status:</span>
                <span>{order.status}</span>
              </li>
              <li>
                <span>Overdue:</span>
                <span>{order.minutesOverdue}m</span>
              </li>
              <div className="mt-3">
                {phone && (
                  <>
                    <Button
                      type="link"
                      size="small"
                      icon={<PhoneOutlined />}
                      onClick={() => {
                        window.open(`tel:${phone}`);
                      }}
                    >
                      Call {contactName}
                    </Button>
                    <Button
                      type="link"
                      size="small"
                      icon={<WhatsAppOutlined />}
                      onClick={() => {
                        window.open(
                          `https://wa.me/${phone}?text=Regarding order ${order.orderCode}`,
                        );
                      }}
                      style={{ marginLeft: "8px" }}
                    >
                      WhatsApp
                    </Button>
                  </>
                )}
                <Button
                  type="link"
                  size="small"
                  icon={<EyeOutlined />}
                  onClick={() => onViewOrder(order)}
                  style={{ marginLeft: phone ? "8px" : "0" }}
                >
                  View Order
                </Button>
              </div>
            </ul>
          </div>
        ),
      };
    });
  };

  if (loading) {
    return <div className="text-center py-8">Loading violations...</div>;
  }

  if (orders.length === 0) {
    return (
      <Empty
        description="No SLA violations in this category"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      >
        <Button onClick={onRefresh}>Refresh Data</Button>
      </Empty>
    );
  }

  return (
    <div className="space-y-4">
      <div className="mobile topup-data">
        <Collapse items={renderCollapseItems()} defaultActiveKey={[0]} />
      </div>

      {filteredOrders.length > 0 && (
        <div className="flex justify-center">
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={filteredOrders.length}
            onChange={setCurrentPage}
            onShowSizeChange={(_, size) => {
              setPageSize(size);
              setCurrentPage(1);
            }}
            showSizeChanger
          />
        </div>
      )}
    </div>
  );
};

export default SLAViolationOrders;
